import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Avatar from 'features/shared/components/avatar/Avatar';
import OverlayButton from 'features/shared/components/buttons/OverlayButton';
import Card from 'features/shared/components/card/Card';
import React from 'react';
import styles from './cardLink.module.scss';

interface Props {
  title: string;
  icon?: IconProp;
  iconAsAvatar?: boolean;
  className?: string;
  onClick?: () => void;
}

const CardLink = ({ title, icon, iconAsAvatar = true, className, onClick }: Props) => {
  // sub-renders
  const renderIcon = () => {
    if (icon) {
      if (iconAsAvatar) {
        return (
          <div className={`col-auto ${styles.iconCol}`}>
            <Avatar icon={icon} size={36} disableShadow />
          </div>
        );
      } else {
        return (
          <div className={`col-auto ${styles.iconCol}`}>
            <span className="text-secondary">
              <FontAwesomeIcon icon={icon} size="lg" />
            </span>
          </div>
        );
      }
    }
  }

  // render
  return (
    <Card className={`${styles.card}${className ? " " + className : ""}`}>
      <OverlayButton onClick={onClick}>
        <div className="row no-gutters align-items-center">
          {renderIcon()}
          <div className="col">
            <h6 className="mb-0">
              {title}
            </h6>
          </div>
          <div className="col-auto pl-3">
            <span className={styles.chevron}>
              <FontAwesomeIcon icon="chevron-right" />
            </span>
          </div>
        </div>
      </OverlayButton>
    </Card>
  )
}

export default CardLink;
